<!-- 问答 -->
<template>
	<div class="essay">
		<div class="content" v-if="info">
			<div class="title fontSize14">
				【{{quesMap[info.type]}}】{{info.no?info.no:(Number(no)+1)}}、<span v-html="reformHtml(info.content)"></span>
				<!-- <div style="white-space: nowrap;">【{{quesMap[info.type]}}】{{info.no?info.no:(Number(no)+1)}}、</div><span v-html="reformHtml(info.content)"></span> -->
			</div>
			<div class="txts" v-if="!readOnly">
				<textarea v-model="info.myAnswer" placeholder="请输入" @input="change"></textarea>
			</div>
			<!-- 解析 -->
			<div class="analysisBox" v-if="readOnly">
				<div v-if="showAnswer">标准答案：<span v-html="info.key||info.answer"></span></div>
				<div v-if="showAnswer && answerExpose && (info.ext||info.analysis)">答案解析：<span v-html="info.ext||info.analysis"></span></div>
				<div class="d-flex d-flex-middle">我的答案：{{ info.myAnswer }}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {quesMap} from '@/utils/enums'
	export default {
		name:"essay",
		props:{
			info:{},
			no:'',
			readOnly: false,
			showAnswer:{
				default: false
			},
			answerExpose:{
				default: false
			}
		},
		data() {
			return {
				quesMap,
			};
		},
		methods:{
			reformHtml(html){
				const regex = new RegExp('<img', 'gi');
      			html= html.replace(regex, `<img style="max-width: 100%;"`);
				return html//.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
			},
			change(e){
				var data = {
					id: this.info.id,
					value: this.info.myAnswer
				}
				this.$emit('change',data)
			}
		}
	}
</script>

<style lang="scss">
.essay{
	font-size: 14px;
	p{
		margin: 0;
	}
	.content{
		.title{
			margin-bottom: 15px;
			line-height: 20px;
			// width: calc(100% - 200px);
			&.all{
				width: 100%;
			}
		}
		.txts{
			textarea{
				width: 100%;
				border: 1px solid #999;
				border-radius: 10px;
				height: 100px;
				line-height: 20px;
				margin-bottom: 15px;
				box-sizing: border-box;
				padding: 5px 10px;
				font-size: 14px;
			}
		}
		.analysisBox{
			box-sizing: border-box;
			padding: 5px 10px;
			border-radius: 5px;
			background: #eee;
			margin: 10px 0;
			max-height: 200px;
			overflow-y: auto;
			div{
				margin: 5px 0;
				word-break: break-all;
			}
		}
	}
}
</style>
